import '../../../css/info_components/info_title.css'

function WashingMachineTitle() {
    return (
        <main>
            <div className='info_all_parent'>
                <font className='page_nav_font_active'>
                    Washing Machine Time
                </font>
            </div>
        </main>
    );
}

export default WashingMachineTitle;